export const iconFontAwesomeShoppingStripe = (
	<i className="fa-solid fa-stripe"></i>
);
